export default {"id":"icon-logo"}